export const SETTINGS = Object.assign(
    {
        serverUrl: Bun.env.SERVER_URL,
        totalApiUrl: Bun.env.TOTAL_API_URL,
        totalKey: Bun.env.TOTAL_API_KEY,
        hotDataUrl: Bun.env.HOT_DATA_API_URL,
        totalExternalUrl: Bun.env.TOTAL_EXTERNAL_URL,
        mapStyles: [
            {
                stylers: [{ saturation: -70 }],
            },
            {
                featureType: "road.highway",
                stylers: [{ lightness: 33 }],
            },
            {
                featureType: "poi",
                stylers: [{ visibility: "off" }],
            },
        ],
        paddingBounds: { left: 400, top: 100, bottom: 100 },
        mobilePaddingBounds: { top: 260, bottom: 70 },
        enableScrollWheel: true,
        rendererBreakScale: 12,
        simpleRendererPointSize: 10,
        simpleRendererMinPointSize: 4,
        directionRendererOptions: {
            suppressMarkers: true,
            suppressInfoWindows: true,
            preserveViewport: true,
            polylineOptions: {
                strokeColor: "#cc0000",
                strokeOpacity: 1.0,
                strokeWeight: 4,
            },
        },
        itinaryRendererOptions: {
            suppressMarkers: true,
            suppressInfoWindows: true,
            preserveViewport: true,
            polylineOptions: {
                strokeColor: "#707173",
                strokeOpacity: 1.0,
                strokeWeight: 4,
            },
        },
        googleDirectionsRequestOptions: {
            provideRouteAlternatives: true,
            durationInTraffic: true,
            language: "en",
        },
        showPrices: false,
        //TO DO LATER..TEMP FIX
        iconUrls: {
            brand: {
                TOTAL: {
                    icon: {
                        default: "https://total-dev-asset-images.s3.eu-west-3.amazonaws.com/TOTAL_ENERGIES.jpg",
                        wash: "https://total-dev-asset-images.s3.eu-west-3.amazonaws.com/WASH.png",
                        ev: "https://total-dev-asset-images.s3.eu-west-3.amazonaws.com/EV.png",
                    },
                    marker: {
                        default: "https://total-dev-asset-images.s3.eu-west-3.amazonaws.com/TOTAL_ENERGIES-0.jpg",
                        wash: "https://total-dev-asset-images.s3.eu-west-3.amazonaws.com/WASH-0.png",
                        ev: "https://total-dev-asset-images.s3.eu-west-3.amazonaws.com/EV-0.png",
                    },
                    selectedMarker: {
                        default: "https://total-dev-asset-images.s3.eu-west-3.amazonaws.com/TOTAL_ENERGIES-select.jpg",
                        wash: "https://total-dev-asset-images.s3.eu-west-3.amazonaws.com/WASH-select.png",
                        ev: "https://total-dev-asset-images.s3.eu-west-3.amazonaws.com/EV-select.png",
                    },
                    markerNumber: {
                        default:
                            "https://total-dev-asset-images.s3.eu-west-3.amazonaws.com/TOTAL_ENERGIES-{number}.jpg",
                        wash: "https://total-dev-asset-images.s3.eu-west-3.amazonaws.com/WASH-{number}.png",
                        ev: "https://total-dev-asset-images.s3.eu-west-3.amazonaws.com/EV-{number}.png",
                    },
                },
            },
        },
        isAviationPortal: false,
        isSearchAlongTheRouteActive: false,
    },
    total.maps.settings || {},
);

SETTINGS.defaultBrandMarkerIcon = `${SETTINGS.serverUrl}css/images/map-icons/brands/picto-OTHER-normal.png`;
SETTINGS.defaultBrandIcon = `${SETTINGS.serverUrl}css/images/icons/brands/other.png`;
SETTINGS.defaultNumberBrandIcon = `${SETTINGS.serverUrl}css/images/map-icons/brands/other-number-{number}.png`;
SETTINGS.defaultSelectBrandMarkerIcon = `${SETTINGS.serverUrl}css/images/map-icons/brands/picto-OTHER-select.png`;
